import CategoryTag from "@/components/base/CategoryTag";
import type { StoreCard as StoreCardType } from "@/types/content";

interface StoreCardProps {
  store: StoreCardType;
  aspectRatio?: "4/3" | "16/10";
  padding?: "normal" | "compact";
  titleClassName?: string;
  surface?: "white" | "alt";
  tags?: React.ReactNode;
  imageOverlay?: React.ReactNode;
  footer?: React.ReactNode;
  className?: string;
  showCta?: boolean;
}

export default function StoreCard({
  store,
  aspectRatio = "4/3",
  padding = "normal",
  titleClassName,
  surface = "white",
  tags,
  imageOverlay,
  footer,
  className = "",
  showCta = true,
}: StoreCardProps) {
  const padClass = padding === "compact" ? "p-4" : "p-4 md:p-5";
  const defaultTitle = padding === "compact" ? "text-sm" : "text-base md:text-lg";
  const surfaceClass = surface === "alt" ? "bg-surface-alt" : "bg-white";

  return (
    <a
      href={`/stores/${store.slug}`}
      className={`group block rounded-xl overflow-hidden card-shadow hover:card-shadow-hover transition-all duration-300 ${surfaceClass} ${className}`}
    >
      <div
        className={`relative ${aspectRatio === "16/10" ? "aspect-[16/10]" : "aspect-[4/3]"} overflow-hidden`}
      >
        <img
          loading="lazy"
          src={store.coverImage}
          alt={store.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-3 left-3 flex gap-2">
          <CategoryTag label={store.category} variant="colored" />
          {tags}
        </div>
        {imageOverlay}
      </div>
      <div className={padClass}>
        <h3
          className={`${titleClassName || defaultTitle} font-semibold text-slate-800 group-hover:text-primary transition-colors ${padding === "compact" ? "line-clamp-2 mb-2" : "mb-2"}`}
        >
          {store.name}
        </h3>
        {footer}
        {showCta && (
          <div className="mt-3 flex items-center gap-1 text-sm font-medium text-primary">
            查看店家
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line" />
            </div>
          </div>
        )}
      </div>
    </a>
  );
}